"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import headerStyles from './Header.module.css.mjs';
import clsx from 'clsx';
import { ActiveFilters } from './components/ActiveFilters/ActiveFilters.mjs';
import { useList } from '../../hooks/useList.mjs';
import { SearchField } from './components/SearchField/SearchField.mjs';
import { ViewModeMenu } from './components/Settings/ViewModeMenu.mjs';
import { TunnelExit } from '@mittwald/react-tunnel';
import DivView from '../../../../views/DivView.mjs';
import { SettingsMenu } from './components/Settings/SettingsMenu.mjs';
import { SortingMenu } from './components/Settings/SortingMenu.mjs';
import { FilterMenuList } from './components/Filters/FilterMenuList.mjs';
import { CombinedFilterMenu } from './components/Filters/CombinedFilterMenu.mjs';
import { useAvailableViewModes } from './lib.mjs';

const Header = (props) => {
  const { className } = props;
  const list = useList();
  const availableViewModes = useAvailableViewModes();
  const hasOptions = list.filters.length > 0 || list.visibleSorting.length > 0 || list.search || availableViewModes.length > 1;
  return /* @__PURE__ */ jsxs(DivView, { className: clsx(className, headerStyles.header), children: [
    /* @__PURE__ */ jsxs(DivView, { className: headerStyles.headerContent, children: [
      /* @__PURE__ */ jsx(TunnelExit, { id: "actions" }),
      hasOptions && /* @__PURE__ */ jsxs(DivView, { className: headerStyles.options, children: [
        /* @__PURE__ */ jsx(ViewModeMenu, {}),
        /* @__PURE__ */ jsx(SortingMenu, {}),
        /* @__PURE__ */ jsx(FilterMenuList, {}),
        /* @__PURE__ */ jsx(SettingsMenu, {}),
        /* @__PURE__ */ jsx(CombinedFilterMenu, {}),
        list.search && /* @__PURE__ */ jsx(SearchField, { search: list.search })
      ] })
    ] }),
    /* @__PURE__ */ jsx(ActiveFilters, {})
  ] });
};

export { Header, Header as default };
//# sourceMappingURL=Header.mjs.map
